import req from "@/assets/js/axios"

export default {
    // 获取首页热门设计任务
    getHotAssigns: (params) => {
        return req.apiAxios('POST', '/assign/assignController/getHotAssigns', params)
    },
    // 获取设计任务列表
    getFrontAssigns: (params) => {
        return req.apiAxios('POST', '/assign/assignController/getFrontAssigns', params)
    },
    // 相关推荐
    getRecommend: (params) => {
        return req.apiAxios('POST', '/assign/assignController/getRecommend', params)
    },
    // 品牌商
    getBrands: (params) => {
        return req.apiAxios('POST', '/brand/BrandController/getBrands', params)
    },
    // // 收藏
    // createFrontCollection: (params) => {
    //     return req.apiAxios('POST', '/host/collection/CollectionController/starry-security/createFrontCollection', params)
    // }, 
    // 投稿
    taskSubmit: (params) => {
        return req.apiAxios('POST', '/business/assignsubmit/BAssignSubmitController/whale-security/submit', params)
    }, 
    // 新增作品
    createOpus: (params) => {
        return req.apiAxios('POST', '/opus/OpusController/whale-security/createOpus', params)
    }, 
    // 已报名设计师
    getAssignSubmitDesigners: (params) => {
        return req.apiAxios('POST', '/business/assign/BAssignController/getAssignSubmitDesigners', params)
    },
    // 已投稿作品
    getAssignSubmits: (params) => {
        return req.apiAxios('POST', '/assignSubmit/assignSubmitController/whale-security/getAssignSubmits', params)
    },
    // 更新投稿
    updateAssignSubmit: (params) => {
        return req.apiAxios('POST', '/assignSubmit/assignSubmitController/whale-security/updateAssignSubmit', params)
    },
    

}
